import deviceTrackingApi from '../../api/deviceTracking';

const state = {
  userDevices: [],
  suspiciousUsers: [],
  deviceAnalysis: null,
  loading: false,
  error: null
};

const getters = {
  userDevices: state => state.userDevices,
  suspiciousUsers: state => state.suspiciousUsers,
  deviceAnalysis: state => state.deviceAnalysis,
  loading: state => state.loading,
  error: state => state.error,
  suspiciousUsersCount: state => state.suspiciousUsers.length,
  highRiskUsers: state => state.suspiciousUsers.filter(user => user.risk_level === 'HIGH'),
  mediumRiskUsers: state => state.suspiciousUsers.filter(user => user.risk_level === 'MEDIUM')
};

const actions = {
  async fetchUserDevices({ commit, rootState }, userId) {
    commit('setLoading', true);
    commit('setError', null);
    
    try {
      const { apptoken } = rootState.appauth;
      if (!apptoken) {
        throw new Error('No authentication token available');
      }
      
      const response = await deviceTrackingApi.getUserDevices(apptoken, userId);
      
      if (response.data.status === 'success') {
        commit('setUserDevices', response.data.devices);
      } else {
        throw new Error(response.data.message || 'Failed to fetch user devices');
      }
    } catch (error) {
      console.error('Error fetching user devices:', error);
      commit('setError', error.response?.data?.message || error.message || 'Failed to fetch user devices');
    } finally {
      commit('setLoading', false);
    }
  },

  async fetchSuspiciousUsers({ commit, rootState }, { minDevices = 4, daysBack = 7 } = {}) {
    console.log('=== VUEX ACTION: fetchSuspiciousUsers ===');
    console.log('Parameters:', { minDevices, daysBack });
    console.log('RootState appauth:', rootState.appauth);
    
    commit('setLoading', true);
    commit('setError', null);
    
    try {
      const { apptoken } = rootState.appauth;
      console.log('App token:', apptoken ? 'Present' : 'Missing');
      
      if (!apptoken) {
        throw new Error('No authentication token available');
      }
      
      console.log('Calling API...');
      const response = await deviceTrackingApi.getSuspiciousUsers(apptoken, minDevices, daysBack);
      console.log('API call completed, response:', response);
      
      if (response.data.status === 'success') {
        console.log('Success! Setting suspicious users:', response.data.suspicious_users);
        commit('setSuspiciousUsers', response.data.suspicious_users);
      } else {
        console.log('API returned error status:', response.data);
        throw new Error(response.data.message || 'Failed to fetch suspicious users');
      }
    } catch (error) {
      console.error('Error in fetchSuspiciousUsers:', error);
      console.error('Error details:', {
        message: error.message,
        response: error.response,
        stack: error.stack
      });
      commit('setError', error.response?.data?.message || error.message || 'Failed to fetch suspicious users');
    } finally {
      commit('setLoading', false);
    }
  },

  async fetchDeviceAnalysis({ commit, rootState }, { userId, daysBack = 30 }) {
    commit('setLoading', true);
    commit('setError', null);
    
    try {
      const { apptoken } = rootState.appauth;
      if (!apptoken) {
        throw new Error('No authentication token available');
      }
      
      const response = await deviceTrackingApi.getDeviceAnalysis(apptoken, userId, daysBack);
      
      if (response.data.status === 'success') {
        commit('setDeviceAnalysis', response.data.analysis);
      } else {
        throw new Error(response.data.message || 'Failed to fetch device analysis');
      }
    } catch (error) {
      console.error('Error fetching device analysis:', error);
      commit('setError', error.response?.data?.message || error.message || 'Failed to fetch device analysis');
    } finally {
      commit('setLoading', false);
    }
  },

  clearData({ commit }) {
    commit('setUserDevices', []);
    commit('setSuspiciousUsers', []);
    commit('setDeviceAnalysis', null);
    commit('setError', null);
  }
};

const mutations = {
  setUserDevices(state, devices) {
    state.userDevices = devices || [];
  },
  
  setSuspiciousUsers(state, users) {
    state.suspiciousUsers = users || [];
  },
  
  setDeviceAnalysis(state, analysis) {
    state.deviceAnalysis = analysis;
  },
  
  setLoading(state, loading) {
    state.loading = loading;
  },
  
  setError(state, error) {
    state.error = error;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}; 